import { BaseCollection, SectionBaseCollection } from "ds/components/ComboBox/types";

export function flattenComboBoxMultipleItems(
  items: Array<BaseCollection | SectionBaseCollection<BaseCollection, object>>
): BaseCollection[] {
  return items.flatMap((item) => ("items" in item ? item.items : [item]));
}

export function flattenComboBoxMultipleSelectableValues(items: BaseCollection[]): string[] {
  const seen = new Set<string>();
  return items
    .filter((item) => !seen.has(item.value) && seen.add(item.value))
    .map((item) => item.value);
}

export function isComboBoxMultipleAllSelected(
  selectable: string[],
  selected: string[] | null | undefined
): boolean {
  if (selectable.length === 0) {
    return false;
  }

  const sel = selected ?? [];
  if (sel.length !== selectable.length) {
    return false;
  }

  const set = new Set(sel);
  return selectable.every((v) => set.has(v));
}
